import Layout from '@/views/universe/Layout.vue';

export default {
    path: '/event-swing',
    component: Layout,
    children: [
        { path: '', component: () => import('@/views/event-swing/EventSwing.vue') },
    ]
};
